const instantAnimationState = {
    current: false,
};

export { instantAnimationState };
